<template>
<div class="o-grid">
    <div data-size="sm:12 md:8 lg:8" class="o-grid__column">
        <div v-for="category in categories" :key="category" class="c-process-list c-buffer-box c-buffer-box--border-all t-background-white t-margin-top-s t-margin-bottom-s">
            <h2 class="t-text-style-beta t-margin-bottom-s">{{category}}</h2>
            <template v-for="process in getProcessesForCategory(category)">
                <process-teaser v-bind="process"></process-teaser>
            </template>
            <template v-if="$can('create', 'Process') || $can('create', 'ProcessTemplate')">
                <router-link class="c-button c-button--primary t-margin-top-s t-margin-bottom-xs" :to="`/create-process/${category}`">Lägg till process</router-link>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import ProcessTeaser from './../process-teaser/ProcessTeaser.vue';

const categoryOrders = {
    'Ledningsprocesser': 1,
    'Huvudprocesser': 2,
    'Stödprocesser': 3
};

export default {
    name: 'Processes',
    props: {
        processes: {
            type: Array,
            default: () => []
        },
        originalProcessIds: {
            type: Array,
            default: () => []
		}
    },
    components: {
        ProcessTeaser
    },
    methods: {
        getProcessesForCategory(category) {
            let processes = this.processes.filter(process => process.category === category);
            /* TODO To be handled by API..? */
            if (this.$can('manage', 'ProcessTemplate')) {
                processes = processes.filter(process => process.processType === 'ProcessTemplate');
            } else if (this.$can('customize', 'ProcessTemplate')) {
                processes = processes.filter(process => !this.originalProcessIds.includes(process.id))
                    .filter(process => !(process.processType === 'ProcessTemplate' && process.status === "Unpublished"));
            } else if (!this.$can('read', 'ProcessTemplate')) {
                processes = processes.filter(process => process.processType === 'Process' && process.status === "Published");
            }
            return processes;
        }
    },
    computed: {
        categories() {
            return [...new Set(this.processes.map(process => process.category))].sort((a, b) => {
                const aSortedValue = categoryOrders[a];
                const bSortedValue = categoryOrders[b];

                if (aSortedValue && bSortedValue) return (aSortedValue - bSortedValue);
                else if (aSortedValue && !bSortedValue) return -1;
                else if (!aSortedValue && bSortedValue) return 1;
                else return a - b;
            });
        }
    },
    created() {}
}
</script>
